import { render } from "./Aks.vue?vue&type=template&id=6bf36159&scoped=true"
import script from "./Aks.vue?vue&type=script&lang=js"
export * from "./Aks.vue?vue&type=script&lang=js"

import "./Aks.vue?vue&type=style&index=0&id=6bf36159&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6bf36159"

export default script